import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, Link, NavLink } from 'react-router-dom';
import { ApiConfig } from "../../api/apiConfig/apiConfig";
import { ProfileContext } from "../../context/ProfileProvider";
import AuthService from '../../api/services/AuthService';
import LoaderHelper from '../Loading/LoaderHelper';
import { alertErrorMessage } from '../CustomAlertMessage';


const AuthHeader = (props) => {
  const [estimatedportfolio, setEstimatedportfolio] = useState();
  const { setCurrentPage, refreshNotification } = useContext(ProfileContext)
  const [showBalance, setShowBalance] = useState(true);
  const [pairs, setPairs] = useState([]);
  const [allData, setAllData] = useState([]);
  const [searchPair, setSearchPair] = useState("");

  const navigate = useNavigate();

  const logOut = () => {
    sessionStorage.clear();
    navigate("/", { replace: true, state: null });
    window.location.reload()
  }
  useEffect(() => {
    getPairs();
    estimatedPortfolio("");
  }, [])


  useEffect(() => {
    handleNotification();
  }, [refreshNotification])

  const estimatedPortfolio = async (type) => {
    try {
      const result = await AuthService.estimatedPortfolio(type)
      if (result?.success) {
        setEstimatedportfolio(result?.data);
      }
    } catch (error) {
    }
  };


  const [isOpenNav, setIsOpenNav] = useState(false);
  const dropdownRef = useRef(null);

  const toggleNavbar = () => setIsOpenNav(!isOpenNav);

  const closeNavbar = () => {
    setIsOpenNav(false);
  };

  // Close mobile nav when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenNav(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const [counts, setCounts] = useState(0);
  const [data, setData] = useState([]);

  const handleNotification = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.notifications();
      LoaderHelper.loaderStatus(false);
      if (result?.success) {
        setData(result?.data?.reverse());
        setCounts(result?.counts);
      } else {
      }
    } catch (err) {
      LoaderHelper.loaderStatus(false);
      alertErrorMessage("Error loading notifications.");
    }
  };
  const getPairs = async () => {
    await AuthService.getPairs().then(async (result) => {
      if (result?.success) {
        try {
          setPairs(result?.data)
          setAllData(result?.data)
        } catch (error) {
        }
      }
    });
  };

  const openAsserOverview = (data) => {
    navigate(`/user_profile/asset_overview`);
  };

  useEffect(() => {
    if (searchPair) {
      const filteredPair = allData?.filter((item) => item?.base_currency?.toLowerCase()?.includes(searchPair?.toLowerCase()));
      setPairs(filteredPair)
    } else {
      setPairs(allData)
    }
  }, [searchPair]);

  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest("#depositSidebar, .deposit-btn")) {
        closeSidebar();
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [openSection, setOpenSection] = useState(null);
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };


  const nextPage = (data) => {
    sessionStorage.setItem("RecentPair", JSON.stringify(data));
    navigate(`/trade/${data?.base_currency}_${data?.quote_currency}`);
    window.location.reload();
  };
  const openNotification = () => {
    navigate(`/user_profile/notification`);
    setCurrentPage("Notification")
  };



  return (
    <>

      {/* {showBonusBanners()} */}
      <header className="sticky-top afterloginheader">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-2 logo_s">
              <div className="logo "><NavLink to="/">
                <img className='lightlogo' src="/images/Vorienx_white.svg" alt="logo" />
              </NavLink></div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-7 navigation_s">
              <div className="navigation">
                <nav className="navbar navbar-expand-lg" ref={dropdownRef}>
                  <div className="container-fluid">
                    {/* Toggle Button */}
                    <button
                      className="navbar-toggler"
                      type="button"
                      onClick={toggleNavbar}
                      aria-controls="mainNavbar"
                      aria-expanded={isOpenNav}
                      aria-label="Toggle navigation"
                    >
                      <span className="navbar-toggler-icon">
                        <img src="/images/toggle_icon.svg" alt="Toggle" />
                      </span>
                    </button>

                    {/* Navbar Links */}
                    <div className={`collapse navbar-collapse ${isOpenNav ? "show" : ""}`} id="mainNavbar">
                      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                          <NavLink className="nav-link" to="/" onClick={closeNavbar}>
                            Home
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink className="nav-link" to="/market" onClick={closeNavbar}>
                            Market
                          </NavLink>
                        </li>

                        <li className="nav-item">
                          <NavLink className="nav-link" to="/trade/BTC_USDT" onClick={closeNavbar}>
                            Trade
                          </NavLink>
                        </li>

                        <li className="nav-item">
                          <NavLink className="nav-link" to="/copy-trading" onClick={closeNavbar}>
                            Copy Trading
                          </NavLink>
                        </li>
                        {/* 
                        <li className="nav-item">
                          <NavLink className="nav-link" to="/refer_earn" onClick={closeNavbar}>
                            Refer & Earn
                          </NavLink>
                        </li> */}

                        <li className="nav-item mememenu">
                          <NavLink className="nav-link" to="/meme" onClick={closeNavbar}>
                            Meme+
                          </NavLink>
                        </li>

                        <li className="nav-item">
                          <NavLink className="nav-link" to="/blogs" onClick={closeNavbar}>
                            Blogs & News
                          </NavLink>
                        </li>


                      </ul>
                    </div>
                  </div>
                </nav>
              </div>
            </div>

            <div className="col-sm-12 col-md-3  col-lg-3">
              <div className="header_right">
                <div className="button_outer">
                  <a className="search_icon" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="ri-search-line"></i></a>
                  <a className="login_btn deposit-btn" href="#/" onClick={toggleSidebar}><i className="ri-download-2-line"></i>Deposit</a>
                  <div className="user_login dashbtn">
                    <Link to="/user_profile/dashboard" >
                      Dashboard

                    </Link>
                    {/* <Link to="#/">
                      {props?.userDetails?.profilepicture ? (
                        <img
                          src={ApiConfig?.baseImage + props?.userDetails?.profilepicture}
                          alt="user"
                          width="30px"
                          height="30px"
                          className="round_img"
                        />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          className="round_img"
                        >
                          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="white" />
                          <path
                            d="M16.5625 15.1656C18.8784 15.1656 20.7559 13.2887 20.7559 10.9734C20.7559 8.65816 18.8784 6.78125 16.5625 6.78125C14.2466 6.78125 12.3691 8.65816 12.3691 10.9734C12.3691 13.2887 14.2466 15.1656 16.5625 15.1656Z"
                            fill="white"
                          />
                          <path
                            d="M21.8151 17.3665C21.0871 16.6007 20.0991 16.1347 19.0452 16.0599C16.9955 15.9306 14.9398 15.9306 12.8901 16.0599C11.8522 16.1353 10.88 16.5958 10.1639 17.3509C9.46079 18.0926 9.07423 19.079 9.08621 20.1009C9.08621 23.295 12.7776 25.0642 16.0671 25.1688H16.3046C19.5139 25.3497 22.9124 23.6052 22.9124 20.4864V20.1595C22.9241 19.1212 22.5304 18.1192 21.8151 17.3665Z"
                            fill="white"
                          />
                        </svg>
                      )}
                    </Link> */}


                  </div>

                </div>
                <div className="icon_notificaton_r">
                  <ul>
                    <li className="notification_nav">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                        <path d="M12.75 5.69531V10.5234H11.25V5.69531H12.75ZM4.7344 13.0312C4.32815 13.7188 4.0508 14.4531 3.90236 15.2344C3.75393 16.0156 3.74221 16.8047 3.86721 17.6016L4.00783 18.3984H19.9922L20.1563 17.6016C20.2969 16.8047 20.2969 16.0156 20.1563 15.2344C20.0156 14.4531 19.7344 13.7188 19.3125 13.0312C19.1406 12.75 18.9922 12.3867 18.8672 11.9414C18.7422 11.4961 18.6797 11.1016 18.6797 10.7578V8.64844C18.6797 7.46094 18.375 6.34375 17.7656 5.29688C17.1719 4.29688 16.375 3.5 15.375 2.90625C14.3438 2.29688 13.2266 1.99219 12.0235 1.99219C10.8203 1.99219 9.69533 2.29688 8.64846 2.90625C7.64846 3.5 6.85158 4.29688 6.25783 5.29688C5.66408 6.32812 5.36721 7.44531 5.36721 8.64844V10.7578C5.36721 11.1016 5.30471 11.4961 5.17971 11.9414C5.05471 12.3867 4.90627 12.75 4.7344 13.0312ZM17.1797 8.67188V10.7578C17.1797 11.2266 17.2617 11.75 17.4258 12.3281C17.5899 12.9062 17.7891 13.3984 18.0235 13.8047C18.6016 14.7578 18.836 15.7891 18.7266 16.8984H5.2969C5.20315 15.7891 5.44533 14.7578 6.02346 13.8047C6.25783 13.3984 6.45705 12.9102 6.62111 12.3398C6.78518 11.7695 6.86721 11.2422 6.86721 10.7578V8.64844C6.86721 7.97656 6.99611 7.32422 7.25393 6.69141C7.51174 6.05859 7.88283 5.5 8.36721 5.01562C8.85158 4.53125 9.41018 4.15625 10.043 3.89062C10.6758 3.625 11.336 3.49219 12.0235 3.49219C12.9453 3.49219 13.8008 3.72656 14.5899 4.19531C15.3789 4.66406 16.0078 5.29297 16.4766 6.08203C16.9453 6.87109 17.1797 7.73438 17.1797 8.67188ZM9.75002 19.0078C9.75002 19.3047 9.80861 19.5898 9.9258 19.8633C10.043 20.1367 10.2071 20.3789 10.418 20.5898C10.6289 20.8008 10.8711 20.9648 11.1446 21.082C11.418 21.1992 11.7031 21.2578 12 21.2578C12.625 21.2422 13.1563 21.0156 13.5938 20.5781C14.0313 20.1406 14.25 19.6172 14.25 19.0078H15.75C15.75 19.6797 15.5821 20.3008 15.2461 20.8711C14.9102 21.4414 14.4531 21.8984 13.875 22.2422C13.2969 22.5859 12.6719 22.7578 12 22.7578C11.5 22.7578 11.0196 22.6602 10.5586 22.4648C10.0977 22.2695 9.69533 21.9961 9.35158 21.6445C9.00783 21.293 8.7383 20.8867 8.54299 20.4258C8.34768 19.9648 8.25002 19.4922 8.25002 19.0078H9.75002Z" fill="white" />
                      </svg>
                      {counts?.unseen > 0 && (
                        <span className="notification_count">{counts.unseen}</span>
                      )}
                      <div className="annousment_s header_notification">
                        {data?.map((item, index) => (
                          <div key={item?._id || index} className={`annousment_left ${!item?.isSeen && "active"}`} onClick={() => !item?.isSeen && openNotification()} >
                            <img src="/images/notification_icon.svg" alt="Notification Icon" />
                            {`${item?.title?.slice(0, 20)}...`}
                            : <span>  {!item?.isSeen && "Read Now"}</span>
                          </div>
                        ))}
                        <div className="more_btn"><NavLink to="/user_profile/notification">More<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
                        </svg></NavLink></div>
                      </div>
                    </li>
                    <li className='wallet_tb' onClick={openAsserOverview}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 50 50" fill="none">
                        <path d="M45.5575 25.9365H43.6845V24.0635C43.6845 20.973 40.875 19.381 38.0655 19.381H9.96954C6.22354 19.381 2.47754 17.1335 2.47754 12.8255C2.47754 8.51752 6.22354 6.27002 9.96954 6.27002H39.189C42.935 6.27002 45.5575 8.89252 45.5575 12.8255V17.508H43.6845V12.825C43.6845 9.92202 41.999 8.14252 39.189 8.14252H9.96954C7.16004 8.14252 4.35054 9.73452 4.35054 12.825C4.35054 15.9155 7.16004 17.5075 9.96954 17.5075H38.065C41.811 17.5075 45.557 19.755 45.557 24.063L45.5575 25.9365Z" fill="white" />
                        <path d="M39.002 43.7304H9.03304C5.00604 43.7304 2.47754 41.123 2.47754 36.97V12.825H4.35054V36.97C4.35054 40.0605 6.03604 41.799 9.03304 41.799H39.0015C41.811 41.799 43.684 39.8675 43.684 36.97V35.0385H45.557V36.97C45.5575 40.9295 42.8415 43.7304 39.002 43.7304Z" fill="white" />
                        <path d="M37.5969 10.0154H8.56494V11.8884H37.5969V10.0154Z" fill="white" />
                        <path d="M37.5969 13.7615H17.9299V15.6345H37.5969V13.7615Z" fill="white" />
                        <path d="M45.5576 36.2385H39.9386C36.8481 36.2385 34.3196 33.71 34.3196 30.6195C34.3196 27.5285 36.8481 25 39.9386 25H45.5576C47.1496 25 48.3671 26.2175 48.3671 27.8095V33.4285C48.3671 35.021 47.1496 36.2385 45.5576 36.2385ZM39.9386 26.873C37.8781 26.873 36.1926 28.5585 36.1926 30.619C36.1926 32.6795 37.8781 34.365 39.9386 34.365H45.5576C46.1196 34.365 46.4941 33.9905 46.4941 33.4285V27.8095C46.4941 27.2475 46.1196 26.873 45.5576 26.873H39.9386Z" fill="white" />
                        <path d="M40.8749 33.4286C39.2829 33.4286 38.0654 32.2111 38.0654 30.6191C38.0654 29.0271 39.2829 27.8096 40.8749 27.8096C42.4669 27.8096 43.6844 29.0271 43.6844 30.6191C43.6844 32.2111 42.4669 33.4286 40.8749 33.4286ZM40.8749 29.6826C40.3129 29.6826 39.9384 30.0571 39.9384 30.6191C39.9384 31.1811 40.3129 31.5556 40.8749 31.5556C41.4369 31.5556 41.8114 31.1811 41.8114 30.6191C41.8114 30.0571 41.4369 29.6826 40.8749 29.6826Z" fill="white" />
                      </svg>
                      <div className='wallet_profile_tab'>
                        <h3>Total Assets
                          {showBalance ?
                            <i className="ri-eye-line mx-2" onClick={() => setShowBalance(false)}></i>
                            :
                            <i className="ri-eye-close-line mx-2" onClick={() => setShowBalance(true)}></i>
                          }
                        </h3>
                        <ul className='wallet_price_list'>
                          <li>{showBalance ? (estimatedportfolio?.dollarPrice?.toFixed(8)) || 0 : "*********"}  USD</li>
                          <li>≈ {showBalance ? estimatedportfolio?.currencyPrice?.toFixed(8) || 0 : "*********"}{" "}{estimatedportfolio?.Currency || "---"}</li>
                        </ul>
                        <div className='wallet_btn_small'>
                          <NavLink to="/asset_managemnet/deposit">Deposit<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                            <path d="M18.75 10.25C18.5858 10.2499 18.4232 10.2822 18.2715 10.345C18.1198 10.4077 17.982 10.4998 17.8659 10.6159C17.7498 10.732 17.6577 10.8698 17.595 11.0215C17.5322 11.1732 17.4999 11.3358 17.5 11.5V15.25H2.5V11.5C2.5 11.1685 2.3683 10.8505 2.13388 10.6161C1.89946 10.3817 1.58152 10.25 1.25 10.25C0.91848 10.25 0.600537 10.3817 0.366117 10.6161C0.131696 10.8505 2.00941e-07 11.1685 2.00941e-07 11.5V16.5C-9.29127e-05 16.6642 0.0321757 16.8268 0.0949611 16.9785C0.157747 17.1302 0.249817 17.268 0.365909 17.3841C0.482001 17.5002 0.619837 17.5923 0.771536 17.655C0.923235 17.7178 1.08582 17.7501 1.25 17.75H18.75C18.9142 17.7501 19.0768 17.7178 19.2285 17.655C19.3802 17.5923 19.518 17.5002 19.6341 17.3841C19.7502 17.268 19.8423 17.1302 19.905 16.9785C19.9678 16.8268 20.0001 16.6642 20 16.5V11.5C20.0001 11.3358 19.9678 11.1732 19.905 11.0215C19.8423 10.8698 19.7502 10.732 19.6341 10.6159C19.518 10.4998 19.3802 10.4077 19.2285 10.345C19.0768 10.2822 18.9142 10.2499 18.75 10.25Z" fill="white" />
                            <path d="M9.11558 12.3838C9.23162 12.4999 9.3694 12.592 9.52104 12.6548C9.67268 12.7177 9.83522 12.75 9.99937 12.75C10.1635 12.75 10.3261 12.7177 10.4777 12.6548C10.6293 12.592 10.7671 12.4999 10.8832 12.3838L14.6332 8.63379C14.8665 8.39917 14.9972 8.0816 14.9968 7.75072C14.9963 7.41984 14.8647 7.10264 14.6307 6.86866C14.3967 6.63469 14.0795 6.50305 13.7486 6.50259C13.4178 6.50212 13.1002 6.63289 12.8656 6.86621L11.2494 8.48242V1.5C11.2494 1.16848 11.1177 0.850537 10.8833 0.616117C10.6488 0.381696 10.3309 0.25 9.99937 0.25C9.66785 0.25 9.34991 0.381696 9.11549 0.616117C8.88106 0.850537 8.74937 1.16848 8.74937 1.5V8.48242L7.13316 6.86621C6.89854 6.63289 6.58097 6.50212 6.25009 6.50259C5.9192 6.50305 5.602 6.63469 5.36803 6.86866C5.13406 7.10264 5.00241 7.41984 5.00195 7.75072C5.00149 8.0816 5.13226 8.39917 5.36558 8.63379L9.11558 12.3838Z" fill="white" />
                          </svg></NavLink>
                          <NavLink to="/asset_managemnet/withdraw">Withdraw<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                            <path d="M18.75 10.25C18.5858 10.2499 18.4232 10.2822 18.2715 10.345C18.1198 10.4077 17.982 10.4998 17.8659 10.6159C17.7498 10.732 17.6577 10.8698 17.595 11.0215C17.5322 11.1732 17.4999 11.3358 17.5 11.5V15.25H2.5V11.5C2.5 11.1685 2.3683 10.8505 2.13388 10.6161C1.89946 10.3817 1.58152 10.25 1.25 10.25C0.91848 10.25 0.600537 10.3817 0.366117 10.6161C0.131696 10.8505 2.00941e-07 11.1685 2.00941e-07 11.5V16.5C-9.29127e-05 16.6642 0.0321757 16.8268 0.0949611 16.9785C0.157747 17.1302 0.249817 17.268 0.365909 17.3841C0.482001 17.5002 0.619837 17.5923 0.771536 17.655C0.923235 17.7178 1.08582 17.7501 1.25 17.75H18.75C18.9142 17.7501 19.0768 17.7178 19.2285 17.655C19.3802 17.5923 19.518 17.5002 19.6341 17.3841C19.7502 17.268 19.8423 17.1302 19.905 16.9785C19.9678 16.8268 20.0001 16.6642 20 16.5V11.5C20.0001 11.3358 19.9678 11.1732 19.905 11.0215C19.8423 10.8698 19.7502 10.732 19.6341 10.6159C19.518 10.4998 19.3802 10.4077 19.2285 10.345C19.0768 10.2822 18.9142 10.2499 18.75 10.25Z" fill="white" />
                            <path d="M7.13316 6.13379L8.74937 4.51758V11.5C8.74937 11.8315 8.88106 12.1495 9.11549 12.3839C9.34991 12.6183 9.66785 12.75 9.99937 12.75C10.3309 12.75 10.6488 12.6183 10.8833 12.3839C11.1177 12.1495 11.2494 11.8315 11.2494 11.5V4.51758L12.8656 6.13379C13.1002 6.36711 13.4178 6.49787 13.7486 6.49741C14.0795 6.49695 14.3967 6.3653 14.6307 6.13133C14.8647 5.89736 14.9963 5.58016 14.9968 5.24928C14.9972 4.91839 14.8665 4.60083 14.6332 4.36621L10.8832 0.616206C10.7671 0.500108 10.6293 0.408011 10.4777 0.345176C10.3261 0.282341 10.1635 0.25 9.99937 0.25C9.83522 0.25 9.67268 0.282341 9.52104 0.345176C9.3694 0.408011 9.23162 0.500108 9.11558 0.616206L5.36558 4.36621C5.13226 4.60083 5.00149 4.91839 5.00195 5.24928C5.00241 5.58016 5.13406 5.89736 5.36803 6.13133C5.602 6.3653 5.9192 6.49695 6.25009 6.49741C6.58097 6.49787 6.89854 6.36711 7.13316 6.13379Z" fill="white" />
                          </svg></NavLink>
                        </div>
                        <ul className='ac_wallet_info'>
                          <li><NavLink to='/user_profile/asset_overview' onClick={() => setCurrentPage("Overview")}>Account
                            <i className="ri-arrow-right-line"></i>
                          </NavLink></li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <!--Search Bar Modal --> */}
            <div className="modal fade search_form" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-body">
                    <form>
                      <input type="search" placeholder="Search here..." value={searchPair} onChange={(e) => setSearchPair(e.target.value)} />
                    </form>
                    <div className="hot_trading_t">
                      <h3>Hot Trading Pairs</h3>
                      <div className='table-responsive'>
                        <table>
                          <tbody>
                            {pairs?.map((item, index) => {
                              return (
                                <tr key={item?._id || index}>
                                  <td onClick={() => nextPage(item)}>
                                    <div className="td_first">
                                      <div className="icon"><img src={ApiConfig?.baseImage + item?.icon_path} alt="icon" /></div>
                                      <div className="price_heading"> {item?.base_currency} / {item?.quote_currency} <br /> <span>{item?.base_currency_fullname}</span></div>
                                    </div>
                                  </td>
                                  <td className="right_t price_tb">{item?.buy_price}<span className={`${item?.change_percentage > 0 ? "green" : "red"}`}>{item?.change_percentage}%</span></td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header >
      <div className={`sidebar_deposit ${isOpen ? "open" : ""}`} id="depositSidebar">
        <button className="close-btn" onClick={closeSidebar}>&times;</button>
        <h2>I have crypto assets</h2>
        <div className="deposit_list">
          <NavLink to='/asset_managemnet/deposit' className="deposit_option" onClick={closeSidebar}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none"><path d="M18.75 10.25C18.5858 10.2499 18.4232 10.2822 18.2715 10.345C18.1198 
            10.4077 17.982 10.4998 17.8659 10.6159C17.7498 10.732 17.6577 10.8698 17.595 11.0215C17.5322 11.1732 17.4999 11.3358 17.5 11.5V15.25H2.5V11.5C2.5 11.1685 2.3683 10.8505 
            2.13388 10.6161C1.89946 10.3817 1.58152 10.25 1.25 10.25C0.91848 10.25 0.600537 10.3817 0.366117 10.6161C0.131696 10.8505 2.00941e-07 11.1685 2.00941e-07 11.5V16.5C-9.29127e-05 
            16.6642 0.0321757 16.8268 0.0949611 16.9785C0.157747 17.1302 0.249817 17.268 0.365909 17.3841C0.482001 17.5002 0.619837 17.5923 0.771536 17.655C0.923235 17.7178 1.08582 17.7501 
            1.25 17.75H18.75C18.9142 17.7501 19.0768 17.7178 19.2285 17.655C19.3802 17.5923 19.518 17.5002 19.6341 17.3841C19.7502 17.268 19.8423 17.1302 19.905 16.9785C19.9678 16.8268 
            20.0001 16.6642 20 16.5V11.5C20.0001 11.3358 19.9678 11.1732 19.905 11.0215C19.8423 10.8698 19.7502 10.732 19.6341 10.6159C19.518 10.4998 19.3802 10.4077 19.2285 10.345C19.0768
             10.2822 18.9142 10.2499 18.75 10.25Z" fill="white"></path>
              <path d="M9.11558 12.3838C9.23162 12.4999 9.3694 12.592 9.52104 12.6548C9.67268 12.7177 9.83522 12.75 9.99937 12.75C10.1635 12.75 10.3261 12.7177 10.4777 12.6548C10.6293 
            12.592 10.7671 12.4999 10.8832 12.3838L14.6332 8.63379C14.8665 8.39917 14.9972 8.0816 14.9968 7.75072C14.9963 7.41984 14.8647 7.10264 14.6307 6.86866C14.3967 6.63469 
            14.0795 6.50305 13.7486 6.50259C13.4178 6.50212 13.1002 6.63289 12.8656 6.86621L11.2494 8.48242V1.5C11.2494 1.16848 11.1177 0.850537 10.8833 0.616117C10.6488 0.381696 
            10.3309 0.25 9.99937 0.25C9.66785 0.25 9.34991 0.381696 9.11549 0.616117C8.88106 0.850537 8.74937 1.16848 8.74937 1.5V8.48242L7.13316 6.86621C6.89854 6.63289 6.58097 
            6.50212 6.25009 6.50259C5.9192 6.50305 5.602 6.63469 5.36803 6.86866C5.13406 7.10264 5.00241 7.41984 5.00195 7.75072C5.00149 8.0816 5.13226 8.39917 
            5.36558 8.63379L9.11558 12.3838Z" fill="white"></path></svg>
            <div className="deposit_cnt">
              Deposit Crypto
              <p>Send crypto to your Vorienx Account</p>
            </div>
          </NavLink>
        </div>
        <h2 className='mt-4'>Withdraw crypto assets</h2>
        <div className="deposit_list">
          <NavLink to='/asset_managemnet/withdraw' className="deposit_option" onClick={closeSidebar}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
              <path d="M18.75 10.25C18.5858 10.2499 18.4232 10.2822 18.2715 10.345C18.1198 10.4077 17.982 10.4998 17.8659 10.6159C17.7498 10.732
            17.6577 10.8698 17.595 11.0215C17.5322 11.1732 17.4999 11.3358 17.5 11.5V15.25H2.5V11.5C2.5 11.1685 2.3683 10.8505 2.13388 10.6161C1.89946
             10.3817 1.58152 10.25 1.25 10.25C0.91848 10.25 0.600537 10.3817 0.366117 10.6161C0.131696 10.8505 2.00941e-07 11.1685 2.00941e-07
              11.5V16.5C-9.29127e-05 16.6642 0.0321757 16.8268 0.0949611 16.9785C0.157747 17.1302 0.249817 17.268 0.365909 17.3841C0.482001 17.5002
               0.619837 17.5923 0.771536 17.655C0.923235 17.7178 1.08582 17.7501 1.25 17.75H18.75C18.9142 17.7501 19.0768 17.7178 19.2285 17.655C19.3802
                17.5923 19.518 17.5002 19.6341 17.3841C19.7502 17.268 19.8423 17.1302 19.905 16.9785C19.9678 16.8268 20.0001 16.6642 20 16.5V11.5C20.0001
                 11.3358 19.9678 11.1732 19.905 11.0215C19.8423 10.8698 19.7502 10.732 19.6341 10.6159C19.518 10.4998 19.3802 10.4077 19.2285 10.345C19.0768
                  10.2822 18.9142 10.2499 18.75 10.25Z" fill="white"></path><path d="M7.13316 6.13379L8.74937 4.51758V11.5C8.74937 11.8315 8.88106
                   12.1495 9.11549 12.3839C9.34991 12.6183 9.66785 12.75 9.99937 12.75C10.3309 12.75 10.6488 12.6183 10.8833 12.3839C11.1177 12.1495
                    11.2494 11.8315 11.2494 11.5V4.51758L12.8656 6.13379C13.1002 6.36711 13.4178 6.49787 13.7486 6.49741C14.0795 6.49695 14.3967 6.3653
                     14.6307 6.13133C14.8647 5.89736 14.9963 5.58016 14.9968 5.24928C14.9972 4.91839 14.8665 4.60083 14.6332 4.36621L10.8832 0.616206C10.7671
                      0.500108 10.6293 0.408011 10.4777 0.345176C10.3261 0.282341 10.1635 0.25 9.99937 0.25C9.83522 0.25 9.67268 0.282341 9.52104
                       0.345176C9.3694 0.408011 9.23162 0.500108 9.11558 0.616206L5.36558 4.36621C5.13226 4.60083 5.00149 4.91839 5.00195 5.24928C5.00241
                        5.58016 5.13406 5.89736 5.36803 6.13133C5.602 6.3653 5.9192 6.49695
            6.25009 6.49741C6.58097 6.49787 6.89854 6.36711 7.13316 6.13379Z" fill="white"></path></svg>
            <div className="deposit_cnt">
              Withdraw Crypto
              <p>Withdraw crypto to your preferred wallet</p>
            </div>
          </NavLink>
        </div>

      </div>
    </>
  )
}

export default AuthHeader
